import { MediaBlock } from 'components/general/blocks/mediaBlock/MediaBlock';
import Link from 'next/link';
import { NewsItemType } from 'pages/news/[slug]';
import style from './NewsItemCard.module.scss';
import { DESKTOP_BREAKPOINT } from 'pages/_app';

export const NewsItemCard = ({
  title,
  slug,
  date,
  hero,
  category,
  external_url,
}: NewsItemType): JSX.Element => {
  const linkProps = { ...(external_url && { target: '_blank', rel: 'noopener noreferrer' }) };
  return (
    <Link href={external_url ? external_url : '/news/' + slug} passHref={!!external_url}>
      <a className={style.linkWrapper} {...linkProps}>
        <div className={style.container}>
          {/* <div className={style.imageContainer}> */}
          <div className={style.image}>
            <p className={style.imageReadMore}>
              {external_url ? (
                <span className={style.externalLink}>Visit Link</span>
              ) : (
                <span className={style.internalLink}>Read More</span>
              )}
            </p>
            <div className={style.imageDarkener}></div>
            {hero && (
              <div className={style.imageContainer}>
                <MediaBlock
                  media={hero}
                  layout="responsive"
                  sizes={`${DESKTOP_BREAKPOINT} 15vw,
                      100vw`}
                  block_type="media"
                />
              </div>
            )}
          </div>
          <div className={style.metaContainer}>
            <span className={style.date}>
              {category.name}, {date}
            </span>
          </div>
          <div className={style.copyContainer}>
            <div className={style.title} dangerouslySetInnerHTML={{ __html: title }} />
          </div>
          {/* </div> */}
        </div>
      </a>
    </Link>
  );
};
